export default "__VITE_ASSET__7BXT5EP0__"